import { iconsVersionFolder } from './versions';
/**
 * @remarks
 * We are using the Thesis (design-system-web-react-19) CDN urls now
 * @see {@link https://github.com/udemy/design-system-web-react-19/blob/main/packages/icons/src/asset-links.ts}
 */

export const ICON_SPRITEMAP_JS = {
  storybook: `https://frontends.udemycdn.com/thesis/icons/${iconsVersionFolder}/icon-spritemap.js`,
  local: `https://frontends-dev.udemycdn.com/thesis/icons/${iconsVersionFolder}/icon-spritemap.js`,
  dev: `https://frontends-dev.udemycdn.com/thesis/icons/${iconsVersionFolder}/icon-spritemap.js`,
  prod: `https://frontends.udemycdn.com/thesis/icons/${iconsVersionFolder}/icon-spritemap.js`
};
/**
 * @remarks
 * We are using the Thesis (design-system-web-react-19) CDN urls now
 * @see {@link https://github.com/udemy/design-system-web-react-19/blob/main/packages/icons/src/asset-links.ts}
 */

export const ICON_SPRITEMAP_SVG = {
  storybook: `https://frontends.udemycdn.com/thesis/icons//${iconsVersionFolder}/icon-spritemap.svg`,
  local: `https://frontends-dev.udemycdn.com/thesis/icons/${iconsVersionFolder}/icon-spritemap.svg`,
  dev: `https://frontends-dev.udemycdn.com/thesis/icons/${iconsVersionFolder}/icon-spritemap.svg`,
  prod: `https://frontends.udemycdn.com/thesis/icons/${iconsVersionFolder}/icon-spritemap.svg`
};
//# sourceMappingURL=asset-links.js.map